








































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ModalEdit from "@/components/ModalEdit.vue";
import { CMProfile } from "@/models/cm-profile.model";
import {
    CMProfileCompany,
    IProfileCompanyData,
} from "@/models/cm-profile-company.model";
import { CMPRofileApi } from "@/services/api.service";
import { validationMixin } from "vuelidate";
import {
    required,
    requiredUnless,
    minValue,
    helpers,
} from "vuelidate/lib/validators";
import {
    greaterThenEqualAs,
    greaterThenEqualAsIf,
} from "@/lib/cm-validators.lib";
import moment from "moment";

@Component({
    components: {
        ModalEdit,
    },
    mixins: [validationMixin],
    validations: {
        formData: {
            roleRefId: { required },
            company: { required },
            size: { required },
            location: { required },
            monthFrom: { required },
            yearFrom: { required },
            monthTo: {
                requiredUnlessCurrentCompany: requiredUnless(
                    "formData.isCurrentCompany"
                ),
                greaterThenEqualAsMonthFromIf: greaterThenEqualAsIf(
                    "monthFrom",
                    (formData) => formData.yearTo === formData.yearFrom
                ),
            },
            yearTo: {
                requiredUnlessCurrentCompany: requiredUnless(
                    "formData.isCurrentCompany"
                ),
                greaterThenEqualAsYearFrom: greaterThenEqualAs("yearFrom"),
            },
        },
    },
})
export default class ProfileExperience extends Vue {
    public get profile() {
        return this.$store.getters.profile;
    }

    public showEditDialog: boolean = false;
    public saving: boolean = false;
    public now = new Date();
    public titleModalEdit: string = "Edit work experience";
    public flagTitle: number = 0;
    public jobs: any = [];

    public formData = {
        _id: "",
        role: "",
        roleRefId: "",
        company: "",
        location: "",
        size: "",
        monthFrom: 1,
        yearFrom: 2018,
        monthTo: 1,
        yearTo: 2018,
        isCurrentCompany: false,
    };

    get selectedJob() {
        return this.formData.role;
    }
    set selectedJob(val: any) {
        if (val instanceof Object) {
            this.formData.role = val.name;
        }
    }

    public jobSelected(val) {
        this.formData.role = val.name;
        this.formData.roleRefId = val.id;
    }

    private _autocompleteLocation;

    public clearRoleInput() {
        if (!this.jobs.find((el) => el.id === this.formData.roleRefId)) {
            this.selectedJob = "";
            this.formData.roleRefId = "";
        }
    }

    public handleModalClose() {
        this.showEditDialog = false;
    }

    public async openModalEdit(event, id?: string) {
        this.$v.$reset();
        if (!this.jobs.length) {
            this.jobs = await CMPRofileApi.getJobPositionsList();
        }
        if (id) {
            const c = this.profile.experiences.find((s) => {
                return s._id === id;
            });
            this._fillForm(c);
        } else {
            this._emptyForm();
        }
        this.showEditDialog = true;
        setTimeout(() => {
            this._autocompleteLocation = new google.maps.places.Autocomplete(
                (this.$refs.clocation as Vue).$el as HTMLInputElement,
                { types: ["(cities)"] }
            );
            this._autocompleteLocation.addListener(
                "place_changed",
                this.onLocationChange
            );
        }, 200);
    }

    public getYear(i: number): number {
        const nowY = this.now.getUTCFullYear();
        return nowY - i + 1;
    }

    public getFormattedMonth(month: number): string {
        return moment()
            .month(month - 1)
            .format("MMMM");
    }

    public getValidationClass(fieldName, forceInvalid = false) {
        const field = this.$v.formData[fieldName];
        if (field) {
            return {
                "md-invalid": (field.$invalid && field.$dirty) || forceInvalid,
            };
        }
        return "";
    }

    @Watch("formData.isCurrentCompany")
    public onCurrentCompanyChange(val: boolean, oldVal: boolean) {
        if (val) {
            this.formData.monthTo = this.formData.monthFrom;
            this.formData.yearTo = this.formData.yearFrom;
        }
    }

    public async saveExperience() {
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }

        this.saving = true;
        try {
            let companies;
            if (this.formData._id === "") {
                companies = await CMPRofileApi.addCompany(
                    this._getUpdateData()
                );
            } else {
                companies = await CMPRofileApi.updateCompany(
                    this._getUpdateData()
                );
            }
            this.profile.experiences = companies;
            this.$store.commit("updateProfile", this.profile);
        } catch (e) {
            console.error(e);
        } finally {
            this.showEditDialog = false;
            this.saving = false;
        }
    }

    public async deleteExperience() {
        if (this.formData._id !== "") {
            this.saving = true;
            try {
                this.profile.experiences = await CMPRofileApi.deleteCompany(
                    this.formData._id
                );
                this.$store.commit("updateProfile", this.profile);
            } catch (e) {
                console.error(e);
            } finally {
                this.showEditDialog = false;
                this.saving = false;
            }
        } else {
            this.showEditDialog = false;
            this.saving = false;
        }
    }

    public changeTitle(flagTitle) {
        if (flagTitle === 1) {
            this.titleModalEdit = "Add new work experience";
        } else {
            this.titleModalEdit = "Edit work experience";
        }
    }

    private _fillForm(company?: CMProfileCompany) {
        if (!company) {
            return this._emptyForm();
        }
        this.formData._id = company._id;
        this.formData.role = this.jobs.find((el) => el.name === company.role)
            ? company.role
            : "";
        this.formData.roleRefId = company.roleRefId;
        this.formData.company = company.name;
        this.formData.location = company.location;
        this.formData.size = company.size;
        this.formData.monthFrom = company.monthFrom;
        this.formData.yearFrom = company.yearFrom;
        this.formData.isCurrentCompany = company.isCurrentCompany;
        this.formData.monthTo = company.monthTo;
        this.formData.yearTo = company.yearTo;
    }

    private _emptyForm() {
        this.formData._id = "";
        this.formData.role = "";
        this.formData.roleRefId = "";
        this.formData.company = "";
        this.formData.location = "";
        this.formData.size = "";
        this.formData.monthFrom = 1;
        this.formData.yearFrom = this.now.getUTCFullYear();
        this.formData.isCurrentCompany = false;
        this.formData.monthTo = 1;
        this.formData.yearTo = this.now.getUTCFullYear();
    }

    private _getUpdateData(): IProfileCompanyData {
        return {
            _id: this.formData._id,
            name: this.formData.company,
            role: this.formData.role,
            roleRefId: this.formData.roleRefId,
            location: this.formData.location,
            size: this.formData.size,
            isCurrentCompany: this.formData.isCurrentCompany,
            monthFrom: this.formData.monthFrom,
            yearFrom: this.formData.yearFrom,
            monthTo: this.formData.monthTo,
            yearTo: this.formData.yearTo,
        };
    }

    private onLocationChange() {
        this.formData.location = this._autocompleteLocation.getPlace().formatted_address;
    }
}
